import type { EcmConfigurationTarget, SwitchBaseParametersRequest } from '#api/tmsApiService'
import { isFullApiConfiguration, type OverrideableApiConfiguration } from '#features/Configuration/ApiConfiguration'
import { isValidDateString, stringToPeriod, stringToPricingDate } from '#utils/DateString'

export const apiConfigToConfigTarget = (config: OverrideableApiConfiguration, dateSelectionMode?: 'delivery' | 'part'): EcmConfigurationTarget => {
  if (!isFullApiConfiguration(config)) {
    throw new Error('Passing a non-ECM configuration to the ECM configuration target')
  }

  return {
    marketID: config.market,
    vehicleTypeID: config.vehicleType,
    configurationTypeID: config.configurationType,
    viewID: config.view,
    languageID: config.language,
    confirmedPartPeriod: (!dateSelectionMode || dateSelectionMode === 'part') && config.partPeriod ? stringToPeriod(config.partPeriod) : undefined,
    desiredDealerDate:
      (!dateSelectionMode || dateSelectionMode === 'delivery') && config.desiredDealerDate
        ? stringToPricingDate(config.desiredDealerDate)
        : undefined,
  }
}

export const overrideSwitchBaseParameters = (
  config: OverrideableApiConfiguration,
  overrides: Partial<OverrideableApiConfiguration>,
): { ecmParameters: Required<SwitchBaseParametersRequest>['ecmParameters']; apiConfiguration: OverrideableApiConfiguration } => {
  const apiConfiguration = {
    ...config,
    ...overrides,
  }
  const overrideDesiredDealerDate = overrides.desiredDealerDate ?? config.desiredDealerDate
  const overridePartPeriod = overrides.partPeriod ?? config.partPeriod
  const dateSelectionMode = isValidDateString(overrides.desiredDealerDate)
    ? 'delivery'
    : isValidDateString(overrides.partPeriod)
      ? 'part'
      : isValidDateString(config.desiredDealerDate)
        ? 'delivery'
        : 'part'

  if (dateSelectionMode === 'delivery') {
    apiConfiguration.partPeriod = undefined
  } else if (dateSelectionMode === 'part') {
    apiConfiguration.desiredDealerDate = undefined
    apiConfiguration.desiredDealerDateIsEstimate = undefined
  }

  return {
    ecmParameters: {
      marketID: (overrides.market ?? config.market) as number,
      vehicleTypeID: (overrides.vehicleType ?? config.vehicleType) as number,
      // API definition is wrong, it should be optional
      configurationTypeID: (overrides.configurationType ?? config.configurationType) as number,
      viewID: (overrides.view ?? config.view) as number,
      confirmedPartPeriod: isValidDateString(overridePartPeriod) && dateSelectionMode === 'part' ? stringToPeriod(overridePartPeriod) : undefined,
      desiredDealerDate:
        isValidDateString(overrideDesiredDealerDate) && dateSelectionMode === 'delivery' ? stringToPricingDate(overrideDesiredDealerDate) : undefined,
      // API definition is wrong, it should be optional
      languageID: (overrides.language ?? config.language) as number,
    },
    apiConfiguration,
  }
}
